module.exports = __webpack_public_path__ + "media/images/forms-icons/signature-icon-ccf27d0008c2d9307e2a4964875f4fbf.svg";